import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { isBoolean } from '@grandvisionhq/utils';
import { ProductDetailSpecification } from './ProductDetailSpecification.js';
import { SpecificationItem } from './SpecificationItem/SpecificationItem.js';
import { useProductData } from '../../../context/ProductContext.js';

const ProductDetailSpecificationContainer = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant: { specifications  } , specificationConfiguration ,  } = useProductData();
    if (!specificationConfiguration.length || !specifications.length) {
        return null;
    }
    const items = specificationConfiguration.map((configItem)=>{
        const specItem = specifications.find((spec)=>spec.specificationAttribute === configItem.attribute
        );
        if (!specItem) {
            return;
        }
        let value = specItem.value;
        if (isBoolean(value)) {
            value = specItem.value ? getLabel('common.yes') : getLabel('common.no');
        }
        if (configItem.labelPrefix) {
            value = getLabel(`${configItem.labelPrefix}${specItem.value}`);
        }
        return /*#__PURE__*/ React.createElement(SpecificationItem, {
            label: getLabel(configItem.labelKey),
            value: value,
            key: configItem.attribute
        });
    }).filter(Boolean);
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        className: className,
        items: items
    });
};

export { ProductDetailSpecificationContainer };
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
